
import type { PropType } from 'vue'
import { defineComponent } from 'vue'

import formatDate from '@/modern/helpers/formatDate'

export default defineComponent({
    props: {
        date: {
            type: [String, null] as PropType<string | null>,
            default: null
        },
    },
    setup() {
        return { formatDate }
    }
})
